import SmartTable from './SmartTable'

export default SmartTable
